import axios from "axios"

const state = {
  STATUS: null,
  API_ROUTE: "/technician",
  techniciansList: [],
  totalTechnicians: 0
}

const getters = {
  techniciansList: (state) => state.techniciansList,
  totalTechnicians: (state) => state.totalTechnicians
}

const mutations = {
  setTechnicians(state, technicians) {
    state.techniciansList = technicians
  },
  setTotalTechnicians(state, total) {
    state.totalTechnicians = total
  }
}

const actions = {
  async listTechnicians({ commit }, params) {
    try {
      const userId = sessionStorage.getItem("userID");
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/list/${userId}`;
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params
      };
      const response = await window.axios.get(url, config);
      commit("setTechnicians", response.data.technicians);
      commit("setTotalTechnicians", response.data.total);

      return response.data;
    } catch (error) {
      state.STATUS = "An error occurred: " + error;
      throw error;
    }
  },
  async listTechnicianById({ commit }, { id }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/technicianById/${userId}/${id}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.get(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async removeTechnician({ commit }, { id }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${id}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.delete(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async createTechnician({ commit }, { technician }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.post(url, technician, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      if (error.response && error.response.data.detail.message) {
        throw new Error(error.response.data.detail.message || "An error occurred while saving the technician.")
      }
      throw error
    }
  },
  async updateTechnician({ commit }, { technician, id }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${id}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.put(url, technician, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      if (error.response && error.response.data.detail.message) {
        throw new Error(error.response.data.detail.message || "An error occurred while updating the technician.")
      }
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
